export default {
  xs: {
    min: null,
    max: 479
  },
  sm: {
    min: 480,
    max: 767
  },
  md: {
    min: 768,
    max: 1023
  },
  lg: {
    min: 1024,
    max: 1399
  },
  xl: {
    min: 1400,
    max: null
  }
}



// WEBPACK FOOTER //
// ./src/common/lib/breakpoints.js